<template>
  <v-card depressed>
    <v-card-text class="ma-0 pa-0">
      <div ref="mapDiv" id="id1" style="width: 100%; height: 60vh"></div>
      <v-btn
        absolute
        bottom
        left
        fab
        depressed
        color="error"
        v-if="enableDelete"
        @click="deleteZone"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>
import { Loader } from '@googlemaps/js-api-loader'
import { google_maps_loader_key } from '../../../../global'
export default {
  props: ['drawingControlStatus', 'regions', 'cancelHandler', 'centerLocation'],
  data() {
    return {
      google: {},
      loader: null,
      map: {},
      mapRegions: [],
      DrawingManager: {},
      lat: 48.117266,
      lng: -1.6777926,
      type: '',
      radius: '',
      place: '',
      places: [],
      lastId: 0,
      adjuster: {
        center: { lat: 48.117266, lng: -1.6777926 },
        zoom: 13,
        mapTypeControl: true,
        gestureHandling: 'cooperative',
        streetViewControl: false,
        mapTypeControlOptions: {
          mapTypeIds: []
        }
      },
      enableDelete: false,
      editIndex: 0,
      activeZone: {}
    }
  },
  watch: {
    drawingControlStatus: function(value) {
      if (!value) {
        this.DrawingManager.setOptions({
          drawingControl: value,
          drawingMode: null
        })
      } else {
        this.DrawingManager.setOptions({ drawingControl: value })
      }
    },
    regions: function(value) {
      this.resetMap()
      this.manager()
    },
    cancelHandler: function(value) {
      this.resetMap()
      this.manager()
    }
  },
  async mounted() {
    try {
      this.loader = new Loader({
        apiKey: google_maps_loader_key,
        libraries: ['drawing']
      })
      this.google = await this.loader.load()
      this.aftermount(google)
      this.drawingManager(google)
    } catch (err) {
      console.log(err)
    }
  },
  beforeDestroy() {
    this.loader.reset()
    delete window.google
    Loader.instance = undefined
  },
  computed: {},
  methods: {
    async manager() {
      this.mapRegions = []
      if (this.regions.length !== 0) {
        await this.adjustCenterZoom()
      }
      await this.displayRegions()
      this.mapRegions.forEach((region, index) => {
        this.addEditListeners(region, index)
      })
    },
    resetMap() {
      this.mapRegions.forEach(region => {
        region.setMap(null)
      })
    },
    getButtonStatus() {
      return this.enableDelete
    },
    aftermount(google) {
      this.map = new google.maps.Map(document.getElementById('id1'), {
        ...this.adjuster,
        center: this.centerLocation
      })
      new google.maps.Marker({
        position: this.centerLocation,
        map: this.map
      })
      if (this.regions.length) {
        this.manager()
      }
    },
    addEditListeners(region, index) {
      let self = this
      region.getPaths().forEach(function(path, ind) {
        google.maps.event.addListener(path, 'insert_at', function() {
          self.shapeEditing(region, index)
        })
        google.maps.event.addListener(path, 'remove_at', function() {
          self.shapeEditing(region, index)
        })
        google.maps.event.addListener(path, 'set_at', function() {
          self.shapeEditing(region, index)
        })
      })
      google.maps.event.addListener(region, 'dragend', function() {
        self.shapeEditing(region, index)
      })
      google.maps.event.addListener(region, 'click', function(event) {
        if (!self.regions[index].isEditable) {
          self.zoneOptions(region, index)
        }
      })
    },
    zoneOptions(zone, index) {
      this.activeZone = zone
      this.editIndex = index
      this.enableDelete = !this.enableDelete
    },
    deleteZone() {
      // this.activeZone.setMap(null);
      this.emitDeleteRegion()
    },
    drawingManager(google) {
      this.DrawingManager = new google.maps.drawing.DrawingManager(
        this.getDrawingManagerOptions()
      )
      let self = this
      this.DrawingManager.setMap(this.map)
      // this.google.maps.event.addListener(
      //   this.DrawingManager,
      //   ['circlecomplete'],
      //   function (circle) {
      // 	self.shapeComplete(circle)
      //   }
      // )
      this.google.maps.event.addListener(
        this.DrawingManager,
        ['polygoncomplete'],
        function(polygon) {
          self.shapeComplete(polygon)
        }
      )
      // this.google.maps.event.addListener(
      //   this.DrawingManager,
      //   ['rectanglecomplete'],
      //   function (rectangle) {
      // 	self.shapeComplete(rectangle)
      //   }
      // )
      //  this.google.maps.event.addListener(this.DrawingManager, 'click', function () {
      //     //alert the index of the polygon
      // })
    },
    getDrawingManagerOptions() {
      return {
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_LEFT,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON]
        },
        //   circleOptions: {
        // ...this.areaStyles(),
        //     editable: true,
        // draggable: true
        //   },
        //   rectangleOptions: {
        // ...this.areaStyles(),
        //     editable: true,
        // draggable: true,
        //   },
        polygonOptions: {
          ...this.areaStyles(),
          editable: true,
          draggable: true
        }
      }
    },
    areaStyles() {
      return {
        strokeColor: 'black',
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: 'black',
        fillOpacity: 0.4
        // zIndex: 1
      }
    },

    shapeComplete(area) {
      // console.log(area.getCenter())
      // console.log(area.getBounds())//for rectangle
      // console.log(area.getPath().getArray())//for polygon
      let coordinates = area.getPath().getArray()
      coordinates = coordinates.map(vertex => [vertex.lat(), vertex.lng()])
      this.mapRegions.push(area)
      this.mapRegions.forEach((region, index) => {
        this.addEditListeners(region, index)
      })
      this.DrawingManager.setOptions(this.getDrawingManagerOptions())
      this.emitAddRegion({ coordinates })
    },
    shapeEditing(area, index) {
      let coordinates = area.getPath().getArray()
      coordinates = coordinates.map(vertex => [vertex.lat(), vertex.lng()])
      this.emitEditRegion(coordinates, index)
    },
    emitEditRegion(data, index) {
      this.$emit('editRegion', data, index)
    },
    emitAddRegion(data) {
      this.$emit('regionEmitted', data)
    },

    emitDeleteRegion() {
      this.enableDelete = !this.enableDelete
      this.$emit('deleteZoneEmit', this.regions[this.editIndex].id)
    },
    displayRegions() {
      this.regions.forEach((polygon, index) => {
        const paths = polygon.delivery_polygon
        if (paths && paths.length) {
          let newPolygon = new google.maps.Polygon({
            paths: paths.map(vertex => ({
              lat: vertex[0],
              lng: vertex[1]
            })),
            editable: polygon.isEditable,
            draggable: polygon.isEditable,
            strokeColor: 'black',
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: polygon.colour,
            fillOpacity: 0.4
          })
          this.mapRegions.push(newPolygon)
          this.mapRegions[this.mapRegions.length - 1].setMap(this.map)
        }
      })
    },
    adjustCenterZoom() {
      let bounds = new this.google.maps.LatLngBounds()
      this.regions.forEach(region => {
        if (region.delivery_polygon && region.delivery_polygon.length) {
          const paths = region.delivery_polygon
          for (let i = 0; i < paths.length; i++) {
            bounds.extend({
              lat: paths[i][0],
              lng: paths[i][1]
            })
          }
        }
      })
      this.map.fitBounds(bounds)
    }
  }
}
</script>
<style lang="scss">
button[title='Stop drawing'] span {
  padding: 2px;
  height: 40px;
  content: url(https://cdn2.iconfinder.com/data/icons/flat-icons-web/40/Mouse_Cursor-512.png);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
button[title='Draw a shape'] span {
  height: 40px;
  padding: 2px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  content: url(https://cdn0.iconfinder.com/data/icons/phosphor-duotone-vol-3/256/polygon-duotone-512.png);
}
</style>
